import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import MultipleSelectPlatformsMUI from '../dropdowns/MultipleSelectPlatformsMUI';

import '../../../css/layout/cards/PricingPlanCards.css';

const ProfessionalPlanCard = ({
  auth: { isAuthenticated, user },
  plan_id,
  price,
}) => {
  const [planType, setPlanType] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [userEmail, setUserEmail] = useState();
  const [userMobile, setUserMobile] = useState();
  const [userName, setUserName] = useState();

  const [userIp, setUserIp] = useState('');
  const [currency, setCurrency] = useState('');

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [finalPrice, setFinalPrice] = useState(price);

  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      // setPlanType(user.plan_type);
      setUserEmail(user.user_email);
      setUserMobile(user.user_mobile_number);
      setUserName(user.user_name);
    }
  }, [user]);

  // Fetch User's IP Address
  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        setUserIp(data.ip);

        // Save the IP address in local storage
        localStorage.setItem('userIp', data.ip);
      } catch (error) {
        console.error('Error fetching IP address:', error);
      }
    };

    // Check if the user's IP address is already saved in local storage
    const savedUserIp = localStorage.getItem('userIp');
    if (savedUserIp) {
      // console.log('saved user Ip');
      setUserIp(savedUserIp);
    } else {
      // Fetch the user's IP address if it's not saved in local storage
      fetchIpAddress();
    }
  }, []);

  // Fetch Currency based on user's IP address
  useEffect(() => {
    const fetchData = async () => {
      if (!userIp) {
        return; // Wait until userIp is available
      }

      try {
        const config = {
          headers: {
            'Content-Type': 'application/json',
          },
        };

        const body = JSON.stringify({
          ip: userIp,
        });

        const res = await axios.post(
          `${process.env.REACT_APP_API_URI}/ecomnext/api/get-currency`,
          body,
          config
        );

        setCurrency(res.data.currency);

        // console.log('user Ip curr', res.data.currency);
      } catch (error) {
        console.error('Error fetching currency:', error);
      }
    };

    fetchData();
  }, [userIp]);

  const handleAction = (action) => {
    if (!isAuthenticated) {
      navigate('/login', { state: { from: '/pricing', action } });
    } else if (action === 'buy') {
      if (selectedOptions.length === 0) {
        toast.error('Please select platforms to proceed');
        return;
      }
      makePayment();
    }
  };

  useEffect(() => {
    // Calculate final price based on selected platforms
    const updatedPrice =
      selectedOptions.length > 0 ? price * selectedOptions.length : price;
    setFinalPrice(updatedPrice);
  }, [selectedOptions, price]);

  // Redirect and complete the payment
  const makePayment = async () => {
    let amount = finalPrice;

    const items = [
      {
        name: 'Professional Plan',
        price: amount,
        quantity: 1,
      },
    ];

    const config = {
      headers: {
        'Content-Type': 'Application/json',
      },
    };

    const plan_type = 'professional plan';

    const body = JSON.stringify({
      products: items,
      currency: currency,
      amount,
      plan_type,
      duration: 30,
      plan_id,
      selected_platform: selectedOptions,
    });

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URI}/ecomnext/api/create-razorpay-order`,
        body,
        config
      );

      // console.log('Razorpay response', res);
      const orderData = res.data.order;
      // console.log('orderData', orderData);

      var options = {
        key: 'rzp_live_onaaJMJO1fnenw', // Enter the Key ID generated from the Dashboard
        amount: orderData.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
        currency: orderData.currency,
        name: 'Inference Labs', //your business name
        description: 'Test Transaction',
        image:
          'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ4_sLIK2t0j1hSniCVpeqAGvPb_8B8EEv0bZaptyxuCItzKemmsJg0I-0rEz6KQYccFh0&usqp=CAU',
        order_id: orderData.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1

        handler: async function (response) {
          try {
            // Make a request to your backend API to verify the payment
            const verifyPaymentResponse = await axios.post(
              `${process.env.REACT_APP_API_URI}/ecomnext/api/verify-payment`,
              {
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_signature: response.razorpay_signature,
                data: body, // Pass the body object used for storing subscription details
              },
              config
            );

            // console.log('Verify Payment Response:', verifyPaymentResponse);

            // Redirect to the success URL if payment verification is successful
            window.location.href = `https://datazap.ecomnext.ai/pay-success?payment_id=${response.razorpay_payment_id}`;
          } catch (error) {
            console.error('Error verifying payment:', error);

            // Handle the payment verification failure
            toast.error('Payment verification failed');
          }
        },
        prefill: {
          //We recommend using the prefill parameter to auto-fill customer's contact information, especially their phone number
          name: userName, //your customer's name
          email: userEmail,
          contact: userMobile, //Provide the customer's phone number for better conversion rates
        },
        notes: {
          address: 'Razorpay Corporate Office',
        },
        theme: {
          color: '#3399cc',
        },
      };
      var rzp1 = new window.Razorpay(options);

      rzp1.on('payment.failed', function (response) {
        // alert(response.error.code);
        // alert(response.error.description);
        // alert(response.error.source);
        // alert(response.error.step);
        // alert(response.error.reason);
        // alert(response.error.metadata.order_id);
        // alert(response.error.metadata.payment_id);
        // Redirect to the Fail URL if payment verification is unsuccessfull
        // window.location.href = `${process.env.REACT_WEB_URL}/pay-fail`;
        toast.error('Payment Failed, Please Retry');
      });
      rzp1.open();
      // Open Razorpay checkout form
      // razorpay.open();
    } catch (error) {
      console.error('Error making payment:', error);
      toast.error('Payment failed');
    }
  };

  return (
    <div className='professional-plan-card'>
      {/* Top Text */}
      <div>
        <p className='card-top-text'>
          Supporting seller with diverse product <br /> lines to drive growth
        </p>
      </div>

      {/* Plan Name */}
      <h3 className='card-plan-name'>Professional</h3>

      {/* Multi-Select Platforms Dropdown */}
      <div className='mt-3'>
        <MultipleSelectPlatformsMUI
          selectedOptions={selectedOptions}
          setSelectedOptions={setSelectedOptions}
        />
      </div>

      {/* Price */}
      <div className='mt-6'>
        <p>
          <span className='card-pricing-amount'>
            ₹{finalPrice ? `${finalPrice}` : 'Loading...'}
          </span>
          <span className='card-pricing-duration'>/Month</span>
        </p>
      </div>
      <div className='text-[#636363]'>
        <span>~upto 6000 SKUs</span>
      </div>

      {/* Buy Plan Button */}
      <div className='flex justify-center mt-7'>
        {/* <button className='card-buy-button px-3 py-2' onClick={makePayment}> */}
        <button
          className='card-buy-button px-3 py-2'
          onClick={() => handleAction('buy')}
        >
          Buy Plan
        </button>
      </div>

      {/* Description */}
      <div className='mt-7 text-left'>
        <p className='card-description'>
          Advance functionalities including <br /> Insights & Tracking
        </p>
      </div>

      {/* Horizontal Rule */}
      <hr className='card-horizontal-rule' />

      {/* Features Heading */}
      <div>
        <h4 className='card-feature-heading'>Features</h4>
      </div>

      {/* Features List */}
      <ul className='card-feature-list'>
        {[
          'Pricing Insights',
          'Product Description',
          'Product Availability',
          'Keyword Tracking',
          'Email Support',
          'Custom Development',
        ].map((feature, index) => (
          <li key={index} style={{ display: 'flex', alignItems: 'center' }}>
            <span
              style={{
                color: 'green',
                fontSize: '15px',
                marginRight: '8px',
              }}
            >
              ✔
            </span>
            {feature}
          </li>
        ))}
      </ul>
    </div>
  );
};

ProfessionalPlanCard.propTypes = {
  // savePremiumSubDetails: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(ProfessionalPlanCard);

// export default ProfessionalPlanCard;
